import React from 'react';
import {Bar} from 'react-chartjs-2';

export default class BarChart extends React.Component {
	constructor(props) {
		super(props);

	}


	render () {
	
	var data = {
        					    //labels: [0,1,2,3,4,5,6,7,8,9,10,11],
        					    labels: ["0-2", "2-4", "4-6", "6-8", "8-10", "10-12", "12-14", "14-16", "16-18", "18-20", "20-22","22-24"],
        					    datasets: [
        					        {
        					            label: "Abfahrten",
        					            backgroundColor: this.props.color,
        					            borderColor: "rgba(173, 106, 13,0.8)",
        					            highlightFill: "rgba(220,220,220,0.75)",
        					            highlightStroke: "rgba(220,220,220,1)",
        					            data: this.props.departures
        					        }
        					    ]
        					}

      var options = {
		
		scales: {
            yAxes: [{
                labelString: "Anzahl der Abfahrten"
                }
            ]
        },
	legend: {
            display: false
         }
		
			
		}


	return (
<Bar data={data} options={options} />
	)
	}
}





// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/infraresults/departure-chart.js